import { Badge } from "@/components/ui/badge";
import { statusToTone } from "@/lib/format";

export function StatusBadge({ status }: { status: number | null | undefined }) {
  const tone = statusToTone(status);
  const variant = tone === "success" ? "success" : tone === "info" ? "info" : tone === "warn" ? "warn" : tone === "error" ? "error" : "neutral";
  return (
    <Badge variant={variant} className="font-mono">
      {status ?? "—"}
    </Badge>
  );
}
